
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import FilArianne from './fil-arianne';
import { RouteName } from '@/router/routes';

export default Vue.extend({
  name: 'Header',
  components: {
    FilArianne
  },
  props: {
    userName: {
      type: String,
      default: null
    },
    badgeMenu: {
      type: [Boolean, Number, String],
      default: false
    }
  },
  computed: {
    ...mapGetters({ versions: 'infos/versions', itemsOfPanier: 'panier/items' }),
    versionsTooltip (): string {
      return this.versions.frontend + '-' + this.versions.backend;
    }
  },
  created () {
    this.loadVersions();
  },
  methods: {
    ...mapActions({ loadVersions: 'infos/loadVersions', viderPanier: 'panier/viderPanier' }),
    logout () {
      if (this.itemsOfPanier.length > 0) {
        this.$dialog.confirm({
          title: 'Déconnexion',
          text: 'Vous avez un ou plusieurs articles en attente de validation définitive dans votre panier. Si vous quittez votre outil bourse, le contenu du panier sera perdu.',
          width: 500,
          actions: {
            true: { text: 'Quitter quand même', outlined: true, flat: false },
            false: { text: 'Rester sur l\'outil', flat: false }
          }
        }).then(confirm => {
          if (confirm) {
            this.viderPanier();
            this.$emit('logout');
          }
        });
      } else {
        this.$emit('logout');
      }
    },
    clickMenuIcon () {
      this.$emit('clickMenuIcon');
    },
    goToMonCompte () {
      this.$router.push({ name: RouteName.MAIN_MON_COMPTE });
    },
    goToMonPanier () {
      if (this.itemsOfPanier.length === 0) {
        this.$dialog.message.warning('Panier vide', { position: 'top-right', timeout: 1000 });
      } else {
        this.$router.push({ name: RouteName.MAIN_PANIER });
      }
    }
  }
});
